import moment from "moment";
import React, { useState,useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import UserApi from "../../apis/user.api";
import AppAlert from "../../components/AppAlert";
import SolidBlueBtn from "../../components/buttons/SolidBlueBtn";
import Checkbox from "../../components/CheckBox";
import Spinner from "../../components/spinner/Spinner";
import TopPageBack from "../../components/TopPageBack";
import { ROUTE_PATHS } from "../../constants/Router";
import { Button } from "react-scroll";
import OutlineSubBtn from "../../components/buttons/OutlineSubBtn";
import useAuth from "../../hooks/useAuth";
import CeoApi from "../../apis/ceo.api";
import { dispatch, store } from "../../store";
import { updateCeoAccountStatus } from "../../actions/CeoAccountStatus";

const ReasonOfDeletion = () => {
  const [openSuccessDelete, setOpenDeleteSuccess] = useState(false);
  const [comment, setComment] = useState("");
  const [openIncorrect, setOpenIncorrect] = useState(false);

  const [loading, setLoading] = useState(false);
  const [checkboxes, setCheckboxes] = useState([
    { label: "서비스 비용 부담", checked: false },
    { label: "댓글 관리 불필요", checked: false },
    { label: "댓글 품질 불만족", checked: false },
    { label: "오류가 많아서", checked: false },
    { label: "타사 서비스 이용", checked: false },
    { label: "매장 폐업", checked: false },
  ]);

  const location = useLocation();
  const { ceoInfo } = useAuth();
  const state = location.state;

  const navigate = useNavigate();

  const currentDate = moment();

  const firstDayOfNextMonth = currentDate.add(1, 'M').startOf("month");

  const formattedDate = firstDayOfNextMonth.format("YYYY.MM.DD");

  useEffect(()=>{
    window.scrollTo(0, 0);
  },[])
  const updateCeoStatus = async () => {
    if (ceoInfo?.ceo_idx) {
      const response = await CeoApi.getStatus(ceoInfo?.ceo_idx);
      if (response.data.data) {
        await dispatch(updateCeoAccountStatus(response.data.data));
        setOpenDeleteSuccess(true);
      }
    }
  }
  const onSubmit = async () => {
    const checkedCheckboxes = checkboxes.filter((x) => x.checked);
    const selectedReason = checkedCheckboxes
      .map((item) => item.label)
      .toString();
    try {
      let reason;
      if (checkedCheckboxes.length === 0 && !comment) {
        reason = "";
      } else if (checkedCheckboxes.length > 0 && !comment) {
        reason = selectedReason;
      } else if (checkedCheckboxes.length === 0 && comment) {
        reason = comment;
      } else {
        reason = `${selectedReason} - ${comment}`;
      }
      setLoading(true);

      if (state?.type === "delete-account") {
        const res = await UserApi.deleteAccount({
          otp: state?.otp,
          reason,
        });
        if (res.data.data === 0) {
          setOpenIncorrect(true);
        } else {
          updateCeoStatus();
        }
      }

      if (state?.type === "delete-premium") {
        const res = await UserApi.deletePremium({
          reason,
        });
        if (res.data.data === 0) {
          setOpenIncorrect(true);
        } else {
          updateCeoStatus();
        
        }
      }
    } finally {
      setLoading(false);
    }
  };

  const handleCheckboxChange = (index) => {
    const updatedCheckboxes = [...checkboxes];
    updatedCheckboxes[index].checked = !updatedCheckboxes[index].checked;
    setCheckboxes(updatedCheckboxes);
  };

  const ReasonOfDeletionButtonArea = () => {
    if (state?.type === "delete-premium") {
      return <div className="px-5 absolutexx fixed w-full bottom-2 left-0">
        <div className="popup-btns">
          <OutlineSubBtn onClick={() => navigate(ROUTE_PATHS.Home)}
          disabled={loading} className="h-[56px]">
          홈으로
          </OutlineSubBtn>
          <SolidBlueBtn
            disabled={loading}     
            onClick={onSubmit}
          >        
            탈퇴 하기
          </SolidBlueBtn>
        </div>
      {/* <div className="popup-btns">
        <OutlineSubBtn>닫기</OutlineSubBtn>
        <OutlineBlueBtn2 disabled={loading} className="py-3" onClick={notShowFor1Month}>
        탈퇴 하기
        </OutlineBlueBtn2>
      </div> */}
    </div>
    }
    
    if (state?.type === "delete-account") {
      return <div className="px-5 absolutexx fixed w-full bottom-2 left-0">
          <SolidBlueBtn
            disabled={loading}
            className="w-full flex items-center justify-center"
            onClick={onSubmit}
          >          
            탈퇴 완료
          </SolidBlueBtn>
        </div>
    }

    return <></>;
  }
  return (
    <div>
      <TopPageBack>
        <b>프리미엄 탈퇴</b>
      </TopPageBack>
      <div className="mx-5">
        <div className="text-22 text-darkblue font-bold">
          <div>이렇게 떠나신다니 </div>
          <div>너무 아쉬워요.</div>
        </div>

        <div className="text-darkblue text-15 mt-5">
          프리미엄 탈퇴 사유를 알려주시면 적극 반영하고 노력할게요.
        </div>

        <div className="flex mb-3 items-center justify-between mt-10 bg-gray rounded-lg p-4 ">
          <div className="text-darkblue text-15">탈퇴 예정일</div>
          <div className="text-darkblue text-15 font-bold text-base">
            {formattedDate}
            <span className="font-normal">(00시)</span>
          </div>
        </div>

        <ul className="list-disc px-5 text-sm mb-12">
          <li className="text-darkblue">
            탈퇴 예정일까지는 모든 서비스를 정상적으로 이용하실 수 있어요.
          </li>
        </ul>

        {state?.type === "delete-premium" && (
          <div className="text-[15px] mb-4">프리미엄 탈퇴 사유를 알려주세요(<span className="text-appblue">필수</span>)</div>
        )}
        <div className="mx-6">
          {checkboxes.map((checkbox, index) => (
            <div key={index} className="flex items-center gap-1 mb-4">
              <Checkbox
                checked={checkbox.checked}
                onChange={() => handleCheckboxChange(index)}
              />
              <span
                onClick={() => handleCheckboxChange(index)}
                className="text-darkblue text-15 font-bold"
              >
                {checkbox.label}
              </span>
            </div>
          ))}
        </div>

        <textarea
          onChange={(e) => setComment(e.target.value)}
          className="app-textarea mb-32"
          rows={5}
          placeholder="다른 사유나 따로 전하실 말씀이 있다면 남겨주세요."
        />

        <ReasonOfDeletionButtonArea></ReasonOfDeletionButtonArea>
        <Spinner isLoading={loading} />
      </div>

      <AppAlert
        title="탈퇴 신청 접수가 완료되었어요."
        open={openSuccessDelete}
        onOk={() => {
          setOpenDeleteSuccess(false);
          navigate(ROUTE_PATHS.DeleteAccount, { state: { refresh: true } });
        }}
        okText="확인"
        type="success"
      />

      <AppAlert
        title="인증번호가 올바르지 않아요."
        desc="번호를 다시 한번 확인해 주세요."
        open={openIncorrect}
        onOk={() => setOpenIncorrect(false)}
        okText="확인"
        type="error"
      />
    </div>
  );
};

export default ReasonOfDeletion;
